import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams, useHistory, useLocation} from 'react-router-dom';
import GoBackButton from "../layout/GoBackButton";
import {Col, Nav, Row, Tab} from "react-bootstrap";
import { getProduct } from "../../actions/product";
import ProductionDeleteForm from "./ProductionDeleteForm";
import ProductAbout from "./tabs/ProductAbout";
import ProductProductions from "./tabs/ProductProductions";
import ProductSales from "./tabs/ProductSales";

const ProductPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const {id} = useParams();
    
    const {
        product,
    } = useSelector(state => state.product);

    // Determine active tab based on URL
    const getActiveTab = () => {
        const path = location.pathname;
        if (path.includes('/productions')) {
            return 'second';
        } else if (path.includes('/sales')) {
            return 'third';
        } else {
            return 'first'; // default to about tab
        }
    };

    const handleTabSelect = (selectedTab) => {
        switch (selectedTab) {
            case 'first':
                history.push(`/products/${id}`);
                break;
            case 'second':
                history.push(`/products/${id}/productions`);
                break;
            case 'third':
                history.push(`/products/${id}/sales`);
                break;
            default:
                history.push(`/products/${id}`);
        }
    };

    useEffect(() => {
        dispatch(getProduct(id));
    }, [dispatch, getProduct, id]);

    return (
        <div>
            <main className="content mt-0 pt-0">
                <div className="container-fluid p-0">

                    <div className="row mb-4">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-1">
                                <i className="fas fa-box me-2 text-primary"></i>
                                <strong>Mahsulot</strong> sahifasi 
                            </h1>
                            {product && (
                                <p className="text-muted mb-0">
                                    {product.name} - Ma'lumotlar va hisobotlar
                                </p>
                            )}
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <GoBackButton/>
                            </div>
                        </div>
                    </div>
                    {
                        product ? (
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <div className="card shadow-sm">
                                        <Tab.Container id="left-tabs-example" activeKey={getActiveTab()} onSelect={handleTabSelect}>
                                            <Row className="g-0">
                                                <Col sm={3} md={3} className="border-end">
                                                    <div className="p-3">
                                                        <Nav variant="pills" className="flex-column nav-pills-custom">
                                                            <Nav.Item className="mb-2">
                                                                <Nav.Link eventKey="first" className="text-start fw-bold rounded-3">
                                                                    <i className="fas fa-info-circle me-2"></i>
                                                                    Haqida
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item className="mb-2">
                                                                <Nav.Link eventKey="second" className="text-start fw-bold rounded-3">
                                                                    <i className="fas fa-industry me-2"></i>
                                                                    Ishlab chiqarishlar
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item className="mb-2">
                                                                <Nav.Link eventKey="third" className="text-start fw-bold rounded-3">
                                                                    <i className="fas fa-shopping-cart me-2"></i>
                                                                    Sotuvlar
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    </div>
                                                </Col>
                                                <Col sm={9} md={9}>
                                                    <div className="p-4">
                                                        <Tab.Content>
                                                            <Tab.Pane eventKey="first">
                                                                <ProductAbout product={product}/>
                                                            </Tab.Pane>

                                                            <Tab.Pane eventKey="second">
                                                                <ProductProductions />
                                                            </Tab.Pane>

                                                            <Tab.Pane eventKey="third">
                                                                <ProductSales />
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </div>

                        ) : ''
                    }
                </div>

                <ProductionDeleteForm/>

            </main>
        </div>
    );
};

export default ProductPage;